import { useEffect } from 'react';

import { observer } from 'mobx-react-lite';

import { campaignRootStore } from '../../stores/CampaignRootStore';

type LiveUsersControllerProps = {
  campaignId: string;
  orgId: number | null;
};

export const LiveUsersController: React.FC<LiveUsersControllerProps> = observer(({ campaignId, orgId }) => {
  const { liveUsersStore } = campaignRootStore;
  if (!orgId) {
    return null;
  }
  // Check if the campaignId is valid
  useEffect(() => {
    if (campaignId) {
      liveUsersStore.connectWebSocket(campaignId, orgId);
    }

    return () => {
      liveUsersStore.closeWebSocket();
    };
  }, [campaignId]);

  return null;
});
